<script lang="ts" setup>
import type {
  ComponentData,
  ComponentDataWithFreeText,
} from '@autobid/ui/types/components/DetailsTitleWithContent'

interface Props {
  data: ComponentData | ComponentDataWithFreeText | { display: false }
}

defineProps<Props>()
</script>

<template>
  <tr v-if="data.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th" colspan="2">
            {{ data.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <template v-if="'content' in data">
            <SectionsDetailsPdfElementsList
              v-if="Array.isArray(data.content)"
              :elements="data.content"
              :in-two-cols-from="20"
            />

            <tr v-else>
              <td class="whitespace-pre-line pb-2">
                {{ data.content }}
              </td>
            </tr>
          </template>

          <template v-else>
            <SectionsDetailsPdfElementsList
              v-if="data.list.length"
              :elements="data.list"
              :in-two-cols-from="20"
            />

            <SectionsDetailsPdfElementsFreeText
              v-if="data.freeText.length"
              :has-border="data.list.length > 0"
              :free-text="data.freeText"
            />
          </template>
        </tbody>
      </table>
    </td>
  </tr>
</template>
